import { isFunction } from "../utils/is.js";
import { markMetaCaptured } from "./capture.js";
//#region src/metas/initialize.ts
function initializeMetas(_unpatchedConsole, internalLogger, _config) {
	let items = [];
	let listeners = [];
	let captureListeners = [];
	let pendingCaptureListeners;
	let nextCaptureListener = 0;
	let captureListenerCount = 0;
	const getValue = () => items.reduce((acc, item) => Object.assign(acc, isFunction(item) ? item() : item), {});
	const notifyListeners = () => {
		if (listeners.length) {
			const value = getValue();
			listeners.forEach((listener) => listener(value));
		}
	};
	const add = (...newItems) => {
		internalLogger.debug("Adding metas\n", newItems);
		items.push(...newItems);
		notifyListeners();
	};
	const remove = (...itemsToRemove) => {
		internalLogger.debug("Removing metas\n", itemsToRemove);
		items = items.filter((currentItem) => !itemsToRemove.includes(currentItem));
		notifyListeners();
	};
	const addListener = (listener) => {
		internalLogger.debug("Adding metas listener\n", listener);
		listeners.push(listener);
	};
	const removeListener = (listener) => {
		internalLogger.debug("Removing metas listener\n", listener);
		listeners = listeners.filter((currentListener) => currentListener !== listener);
	};
	const capture = (callback) => {
		var _pendingCaptureListen;
		const nested = pendingCaptureListeners !== void 0;
		const cycleListeners = (_pendingCaptureListen = pendingCaptureListeners) !== null && _pendingCaptureListen !== void 0 ? _pendingCaptureListen : captureListeners;
		if (!nested) {
			pendingCaptureListeners = cycleListeners;
			nextCaptureListener = 0;
			captureListenerCount = cycleListeners.length;
		}
		try {
			while (nextCaptureListener < captureListenerCount) {
				const listener = cycleListeners[nextCaptureListener++];
				listener === null || listener === void 0 || listener();
			}
			const value = markMetaCaptured(getValue());
			callback === null || callback === void 0 || callback();
			return value;
		} finally {
			if (!nested) pendingCaptureListeners = void 0;
		}
	};
	return {
		add,
		remove,
		addListener,
		removeListener,
		capture,
		addCaptureListener: (listener) => {
			captureListeners.push(listener);
		},
		removeCaptureListener: (listener) => {
			captureListeners = captureListeners.filter((current) => current !== listener);
		},
		get value() {
			return getValue();
		}
	};
}
//#endregion
export { initializeMetas };

//# sourceMappingURL=initialize.js.map